import React from 'react';
import { Accordion, Col, Row, Table } from 'react-bootstrap';

const YearlyDataTable = ({ data }) => {
  console.log("data",data);
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Year</th>
          <th>Jan</th>
          <th>Feb</th>
          <th>Mar</th>
          <th>Apr</th>
          <th>May</th>
          <th>Jun</th>
          <th>Jul</th>
          <th>Aug</th>
          <th>Sep</th>
          <th>Oct</th>
          <th>Nov</th>
          <th>Dec</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        {data.map((yearData) => (
          <tr key={yearData.year}>
            <td>{yearData.year}</td>
            {yearData.months.map((monthValue, index) => (
              <td key={index}>{monthValue}</td>
            ))}
            <td>{yearData.months.reduce((acc, val) => Number(acc) + Number(val), 0)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

const Submisson = ({ volunteeringGoals, personalDevelopmentGoals, physicalFitnessGoals, explorationGoals }) => {
  console.log("buradane",volunteeringGoals);

  const generateYearlyData = (goalArray) => {
    const yearlyData = {};
  
    goalArray?.map(activity => {
        const date = new Date(activity.fdate);
        const year = date.getFullYear();
        const month = date.getMonth();
  
        // Initialize yearlyData for the year if it doesn't exist
        if (!yearlyData[year]) {
          yearlyData[year] = Array(12).fill(0);
        }
  
        // Add the hours of the activity to the corresponding month
        yearlyData[year][month] += Number(activity.fhour); // Sum the hours
  });
    
 
  
    return Object.entries(yearlyData).map(([year, months]) => ({
      year: parseInt(year, 10),
      months,
    }));
  };
  console.log("listemiz",generateYearlyData(volunteeringGoals));
  const renderAccordions = (goals, goalType) => {
    console.log("goals",goals);
    return (
      <>
        <Accordion defaultActiveKey="0">
          {goals?.map((goal, index) => (
            <>
              <Accordion.Item eventKey={index.toString()} key={index}>
                <div className="d-flex justify-content-between">
                  <Accordion.Header>
                    {goalType.replace("_", " ").toUpperCase()} #{index + 1}
                  </Accordion.Header>
                 
                </div>

                <Accordion.Body>
                    <Table striped bordered hover>
                      <tbody>
                        <tr>
                          <td>What is your goal?
                          </td>
                          <td>
                            {goal.goaldesc} 
                           
                          </td>
                        </tr>
                        <tr>
                          <td>Describe your activities to achieve your goal</td>
                          <td>
                           {goal.goaltype}
                          </td>
                        </tr>
                        <tr>
                          <td>How did your skill level change / advance?</td>
                          <td>
                           {goal.goalcontact}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
        <YearlyDataTable data={generateYearlyData(goal.activities)} />

         
                </Accordion.Body>
              </Accordion.Item>
            </>
          ))}
        </Accordion>

      </>
    );
  };


  return (
    <div style={{ display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}} >
    <div >
      {/* Volunteering Section */}
      <div style={{width:"90vw"}}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>
                <Row>
                  <Col xs={12} md={12}>
                    <h4 className="text-center">VOLUNTEERING</h4>
                  </Col>
                </Row>
              </th>
            </tr>
          </thead>
          <tbody>
            {renderAccordions(volunteeringGoals,"volunteering")}
          </tbody>
        </Table>
      </div>

      {/* Personal Development Section */}
      <div className="mb-5">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>
                <Row>
                  <Col xs={12} md={12}>
                    <h4 className="text-center">PERSONAL DEVELOPMENT</h4>
                  </Col>
                </Row>
              </th>
            </tr>
          </thead>
          <tbody>
          {renderAccordions(personalDevelopmentGoals,"personal_development")}
          </tbody>
        </Table>
      </div>

      {/* Physical Fitness Section */}
      <div className="mb-5">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>
                <Row>
                <Col xs={12} md={12}>
                <h4 className="text-center">PHYSICAL FITNESS</h4>
                  </Col>
                </Row>
              </th>
            </tr>
          </thead>
          <tbody>
          {renderAccordions(physicalFitnessGoals,"physical_fitness")}
          </tbody>
        </Table>
      </div>

      {/* Exploration Section */}
      <div className="mb-5">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>
                <Row>
                  <Col xs={12} md={12}>
                    <h4 className="text-center">EXPLORATION</h4>
                  </Col>
                </Row>
              </th>
            </tr>
          </thead>
          <tbody>
          {renderAccordions(explorationGoals,"exploration")}
          </tbody>
        </Table>
      </div>

      {/* Detailed Write-Up Section for Exploration */}
      <div>
      <Table>
        <tbody>
          <tr>
            <td>
              In addition to the information above, please provide a detailed write-up of your Expedition or Exploration by using the prompts BELOW.
            </td>
          </tr>
          <tr>
            <td>
              Use these questions to guide your Expedition/Exploration write-up. Your write-up should read like a journal entry and provide a detailed account of your trip from start to finish. This should include planning and preparation notes, your planned itinerary, and a detailed day-by-day account of your actual activity. Remember, we can only review what is submitted. Be as thorough as possible about your experience and provide a glimpse into what you learned.
            </td>
          </tr>
          <tr>
            <td>
              <strong>1. How did you plan or prepare for this activity?</strong><br />
              Be as detailed as possible indicating your initiative. Did you investigate and schedule your travel options? Did you research varying venues or locations? Did you coordinate with anyone before your arrival? How did you make your trip or activity happen? If you worked with a group, how did you make this trip happen for you? How did you leave your mark?
            </td>
          </tr>
          <tr>
            <td>
              <strong>2. How was this activity unique and unlike anything you have ever done before?</strong><br />
              How were you immersed in a different culture or environment? If you travel or camp a lot, how was this trip or activity different? How did you expand your horizons and learn about a unique culture or environment? How did this put you outside of your comfort zone? An Expedition/Exploration is about exploring a unique culture or environment - how did you accomplish this?
            </td>
          </tr>
          <tr>
            <td>
              <strong>3. How were you challenged?</strong><br />
              Include examples of thinking on your feet. Before and during your trip, what obstacles did you encounter and how did you handle them? This portion of the program is about taking initiative and rising to challenges that come up while exploring an unfamiliar environment. If you got lost on a foreign subway, did you wait for your parents to direct you or did you take the lead? If a venue was closed unexpectedly, did you make other plans or just go back to a hotel? Show us how you were able to adapt to the real world in a different environment or in planning for your trip. If you worked with a group, how did you show leadership in implementing your trip?
            </td>
          </tr>
          <tr>
            <td>
              <strong>4. Outline a detailed itinerary of what you plan to do.</strong><br />
              Detail your planned trip from start to finish. Make sure you can show at least 6-8 hours of immersion activities each day. Include where you are planning on going and why, how you plan to explore the unique culture or environment (through food, sightseeing, etc.), and how you are going to learn about this new environment. If using public transportation is a large component of your trip, make sure to include your overall plan and method for using it.
            </td>
          </tr>
          <tr>
            <td>
              <strong>5. Provide a detailed write up of your actual trip (a day-to-day account).</strong><br />
              Tell us what you did! This should be the most detailed portion of your write up, including how your plans came to fruition. Include details about what you learned, what you saw, and what you took in. Did all of your plans go smoothly or were there bumps along the road? How did you handle any hiccups? How did you explore the environment or culture for at least 6-8 hours? This should not read like a class assignment or paper, arguing for the validity of your trip and how you found real-world immersion.
            </td>
          </tr>
          <tr>
            <td>
              <strong>6. Is there anything else you think would highlight your accomplishments on your trip?</strong><br />
              What did you take away from your trip? Are you planning to return to this location for future adventures or experiences? Did you discover that you could do something you never expected? Did you try a food for the first time and now can t get enough? Did you communicate in another language and now want to learn more? Did you acquire a new skill that you will use on future travels?
            </td>
          </tr>
          <tr>
            <td>
              <strong>Write-Up Below:													
              </strong><br />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
    </div>
    </div>
  );
};

export default Submisson;